// src/shared/ui/Input.jsx
import React, { useId } from 'react';

import styles from './Input.module.css';

export default function Input({
  label,
  error,
  helper,
  required = false,
  disabled = false,
  id: externalId,
  className = '',
  rightElement,
  ...rest
}) {
  const autoId = useId();
  const id = externalId || autoId;
  const errorId = `${id}-error`;
  const helperId = `${id}-helper`;

  const inputClassNames = [styles.input, error ? styles.error : '', disabled ? styles.disabled : '']
    .filter(Boolean)
    .join(' ');

  const groupClassNames = [
    styles.inputGroup,
    error ? styles.error : '',
    disabled ? styles.disabled : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={styles.wrapper}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
          {required && (
            <span className={styles.required} aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}

      <div className={groupClassNames}>
        <input
          id={id}
          className={inputClassNames}
          disabled={disabled}
          aria-invalid={!!error}
          aria-describedby={
            [error ? errorId : null, helper ? helperId : null].filter(Boolean).join(' ') ||
            undefined
          }
          {...rest}
        />
        {rightElement && <div className={styles.rightElement}>{rightElement}</div>}
      </div>

      {error && (
        <p id={errorId} className={styles.errorText} role="alert">
          {error}
        </p>
      )}
      {!error && helper && (
        <p id={helperId} className={styles.helperText}>
          {helper}
        </p>
      )}
    </div>
  );
}
